export default __webpack_public_path__ + "static/media/requests.305a1d75.svg";